<template>
    <div class="pageContainer DeptRole">
        <el-dialog title="部门角色" :visible.sync="visible" :close-on-click-modal="false">
            <el-table
                :data="tableData"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                border stripe
                default-expand-all
                :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                @selection-change="handleSelectionChange">
                <el-table-column
                    type="selection"
                    width="55">
                </el-table-column>
                <el-table-column prop="role_name" label="角色名称"></el-table-column>
                <el-table-column prop="role_code" label="角色代码"></el-table-column>
                <el-table-column prop="sort" label="排序"></el-table-column>
            </el-table>
    
            <el-row class="flexEnd">
                <el-button size="small" type="default" @click="handleCancel">取消</el-button>
                <el-button size="small" type="primary" @click="handleOk">确认</el-button>
            </el-row>
        </el-dialog>
    </div>
</template>
<script>
	import api from '@/api/api';

	export default {
		name: 'DeptRole',
		data () {
			return {
				visible:false,
				tableData: [],
				multipleSelection:[],
			}
		},
		props: {
			editOptions: {
				type: Object
			}
		},
		methods: {
			handleOk () {
				let ids = ''
				if(this.multipleSelection&&this.multipleSelection.length>0){
					ids = this.multipleSelection.map((item, index) => {
						return item.id
					}).join(',')
					this.$emit('saveRole', ids)
				} else {
					this.$message.warning('请至少选择一条数据')
				}
			},
			handleCancel () {
				// this.$emit('close')
				this.visible = false
			},
			show () {
				this.getList();
				this.visible = true
			},
			getList () {
				this.$http.post(api.deptRoleList).then(res => {
					this.tableData = res.data
				})
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
		}
	}
</script>
